import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  assemblyComponentsMap: {},
  draftedQuotes: [],
  isCopyingAddOns: true,
  isCopyingQuantities: false,
  isCopyingOperations: true,
  isCopyingMaterials: true,
  isCopyingPricingItems: true,
  isCopyingDiscounts: true,
  isCopyingPricing: false,
  isCopyPricingDrawerOpen: false,
  isChoosingQuote: false,
  isFetchingAdditionalQuotes: false,
  isFetchingAssemblyComponentsMap: {},
  isFetchingQuotes: false,
  isFetchingQuoteItems: false,
  quoteItems: [],
  quotesPage: 1,
  hasMoreQuotes: true,
  sourceComponent: undefined,
  isSourceItar: false,
  destinationComponentsMap: {},
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.INIT_COPY_PRICING_DRAWER:
      return {
        ...initialState,
        isSourceItar: payload.isSourceItar,
        quoteItems: payload.quoteItems,
        sourceComponent: payload.sourceComponent,
        selectedQuote: payload.quote,
        initialQuote: payload.quote,
        isCopyPricingDrawerOpen: true,
      };
    case types.CLOSE_COPY_PRICING_DRAWER:
      return {
        ...state,
        isCopyPricingDrawerOpen: false,
      };
    case types.SET_SELECTED_QUOTE:
      return {
        ...state,
        selectedQuote: payload.selectedQuote,
        isChoosingQuote: false,
      };
    case types.SET_IS_CHOOSING_QUOTE:
      return {
        ...state,
        isChoosingQuote: payload.isChoosingQuote,
        quotesPage: 1,
      };
    case types.GET_DRAFTED_QUOTES_REQUEST:
      return {
        ...state,
        isFetchingQuotes: true,
      };
    case types.GET_DRAFTER_QUOTES_SUCCESS:
      return {
        ...state,
        isFetchingQuotes: false,
        draftedQuotes: payload.draftedQuotes,
        hasMoreQuotes: payload.hasMoreQuotes,
      };
    case types.GET_DRAFTED_QUOTES_ERROR:
      return {
        ...state,
        isFetchingQuotes: false,
      };
    case types.GET_ASSEMBLY_COMPONENTS_SUCCESS: {
      const isFetchingAssemblyComponentsMap = {
        ...state.isFetchingAssemblyComponentsMap,
      };
      const assemblyComponentsMap = { ...state.assemblyComponentsMap };
      isFetchingAssemblyComponentsMap[payload.rootComponentId] = false;
      assemblyComponentsMap[payload.rootComponentId] = payload.components;
      return {
        ...state,
        isFetchingAssemblyComponentsMap: isFetchingAssemblyComponentsMap,
        assemblyComponentsMap: assemblyComponentsMap,
      };
    }
    case types.GET_ASSEMBLY_COMPONENTS_REQUEST: {
      const isFetchingAssemblyComponentsMap = {
        ...state.isFetchingAssemblyComponentsMap,
      };
      isFetchingAssemblyComponentsMap[payload.rootComponentId] = true;
      return {
        ...state,
        isFetchingAssemblyComponentsMap: isFetchingAssemblyComponentsMap,
      };
    }
    case types.SELECT_COMPONENT: {
      const destinationComponentsMap = { ...state.destinationComponentsMap };
      destinationComponentsMap[payload.component.id] = payload.component;
      return {
        ...state,
        destinationComponentsMap: destinationComponentsMap,
      };
    }
    case types.DESELECT_COMPONENT: {
      const destinationComponentsMap = { ...state.destinationComponentsMap };
      delete destinationComponentsMap[payload.component.id];
      return {
        ...state,
        destinationComponentsMap: destinationComponentsMap,
      };
    }
    case types.GET_QUOTE_ITEMS_REQUEST: {
      return {
        ...state,
        isFetchingQuoteItems: true,
      };
    }
    case types.GET_QUOTE_ITEMS_SUCCESS: {
      return {
        ...state,
        quoteItems: payload.quoteItems,
        isFetchingQuoteItems: false,
      };
    }
    case types.GET_QUOTE_ITEMS_ERROR: {
      return {
        ...state,
        isFetchingQuoteItems: false,
      };
    }
    case types.SET_IS_COPYING_ADD_ONS:
      return {
        ...state,
        isCopyingAddOns: payload.isCopyingAddOns,
      };
    case types.SET_IS_COPYING_QUANTITIES:
      return {
        ...state,
        isCopyingQuantities: payload.isCopyingQuantities,
      };
    case types.SET_IS_COPYING_MATERIALS:
      return {
        ...state,
        isCopyingMaterials: payload.isCopyingMaterials,
      };
    case types.SET_IS_COPYING_OPERATIONS:
      return {
        ...state,
        isCopyingOperations: payload.isCopyingOperations,
      };
    case types.SET_IS_COPYING_PRICING_ITEMS:
      return {
        ...state,
        isCopyingPricingItems: payload.isCopyingPricingItems,
      };
    case types.SET_IS_COPYING_DISCOUNTS:
      return {
        ...state,
        isCopyingDiscounts: payload.isCopyingDiscounts,
      };
    case types.COPY_PRICING_REQUEST:
      return {
        ...state,
        isCopyingPricing: true,
      };
    case types.COPY_PRICING_SUCCESS:
      return {
        ...state,
        isCopyingPricing: false,
        isCopyPricingDrawerOpen: false,
      };
    case types.COPY_PRICING_ERROR:
      return {
        ...state,
        isCopyingPricing: false,
      };
    case types.GET_ADDITIONAL_QUOTES_REQUEST:
      return {
        ...state,
        isFetchingAdditionalQuotes: true,
      };
    case types.GET_ADDITIONAL_QUOTES_SUCCESS: {
      const draftedQuotes = state.draftedQuotes;
      draftedQuotes.push(...payload.quotes);
      return {
        ...state,
        isFetchingAdditionalQuotes: false,
        draftedQuotes: draftedQuotes,
        quotesPage: payload.page,
        hasMoreQuotes: payload.hasMoreQuotes,
      };
    }
    case types.GET_ADDITIONAL_QUOTES_ERROR: {
      return {
        ...state,
        isFetchingAdditionalQuotes: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.copyPricingDrawer;

export const isCopyPricingDrawerOpen = (state) =>
  getScope(state).isCopyPricingDrawerOpen;

export const getQuoteItems = (state) => getScope(state).quoteItems;

export const getSourceComponent = (state) => getScope(state).sourceComponent;

export const getIsSourceItar = (state) => getScope(state).isSourceItar;

export const isChoosingQuote = (state) => getScope(state).isChoosingQuote;

export const isFetchingDraftedQuotes = (state) =>
  getScope(state).isFetchingQuotes;

export const getDraftedQuotes = (state) => getScope(state).draftedQuotes;

export const getSelectedQuote = (state) => getScope(state).selectedQuote;

export const getInitialQuote = (state) => getScope(state).initialQuote;

export const getIsFetchingAssemblyComponentsMap = (state) =>
  getScope(state).isFetchingAssemblyComponentsMap;

export const getAssemblyComponentsMap = (state) =>
  getScope(state).assemblyComponentsMap;

export const getDestinationComponentsMap = (state) =>
  getScope(state).destinationComponentsMap;

export const isFetchingQuoteItems = (state) =>
  getScope(state).isFetchingQuoteItems;

export const isCopyingAddOns = (state) => getScope(state).isCopyingAddOns;

export const isCopyingQuantities = (state) =>
  getScope(state).isCopyingQuantities;

export const isCopyingMaterials = (state) => getScope(state).isCopyingMaterials;

export const isCopyingOperations = (state) =>
  getScope(state).isCopyingOperations;

export const isCopyingPricingItems = (state) =>
  getScope(state).isCopyingPricingItems;

export const isCopyingDiscounts = (state) => getScope(state).isCopyingDiscounts;

export const getDestinationComponentsArray = (state) =>
  Object.values(getScope(state).destinationComponentsMap);

export const hasDestinationComponentsSelected = (state) =>
  getDestinationComponentsArray(state).length > 0;

export const hasSubComponentSelected = (state) =>
  Boolean(
    getDestinationComponentsArray(state).find((comp) => !comp.isRootComponent),
  );

export const hasSourcePropertySelected = (state) =>
  isCopyingAddOns(state) ||
  isCopyingMaterials(state) ||
  isCopyingOperations(state) ||
  isCopyingPricingItems(state) ||
  isCopyingDiscounts(state) ||
  isCopyingQuantities(state);

export const getSelectedProperties = (state) => {
  return (({
    isCopyingAddOns,
    isCopyingMaterials,
    isCopyingOperations,
    isCopyingPricingItems,
    isCopyingDiscounts,
    isCopyingQuantities,
  }) => ({
    isCopyingAddOns,
    isCopyingQuantities,
    isCopyingMaterials,
    isCopyingPricingItems,
    isCopyingDiscounts,
    isCopyingOperations,
  }))(getScope(state));
};

export const isCopyingPricing = (state) => getScope(state).isCopyingPricing;

export const getQuotesPage = (state) => getScope(state).quotesPage;

export const isFetchingAdditionalQuotes = (state) =>
  getScope(state).isFetchingAdditionalQuotes;

export const hasMoreQuotes = (state) => getScope(state).hasMoreQuotes;
